import { EXECUTIVE_GOVERNOR_PLACEMENT_MAP } from "@/governor/placement/ExecutiveGovernorPlacementMap";
import { GOVERNOR_MASTER_INVENTORY } from "@/governor/inventory/GovernorMasterInventory";
import { GOVERNOR_MATURITY_MATRIX } from "@/governor/maturity/GovernorMaturityMatrix";

export interface ExecutiveGovernorActivationNode {
  id: string;
  name: string;
  active: boolean;
  maturity: string;
  inventoryStatus: string;
  evidence: string[];
}

export interface ExecutiveGovernorActivationReport {
  executive: string;
  supervisedGovernors: ExecutiveGovernorActivationNode[];
  activatedCount: number;
}

export function buildExecutiveGovernorActivationReport(): ExecutiveGovernorActivationReport {
  const executive = EXECUTIVE_GOVERNOR_PLACEMENT_MAP.find(g => g.id === "executive");

  const supervisedGovernors =
    executive?.children.map(id => {
      const placement = EXECUTIVE_GOVERNOR_PLACEMENT_MAP.find(g => g.id === id);
      const maturity = (GOVERNOR_MATURITY_MATRIX as any[]).find(m => m.id === id);
      const inventory = (GOVERNOR_MASTER_INVENTORY as any[]).find(i => i.id === id);

      const inventoryStatus =
        inventory?.status ?? (inventory?.enabled ? "ACTIVE" : "UNMAPPED");

      const active =
        Boolean(maturity?.runtimeEvidence) ||
        inventoryStatus === "ACTIVE" ||
        inventoryStatus === "RUNTIME";

      return {
        id,
        name: placement?.name ?? id,
        active,
        maturity: maturity?.level ?? "UNMAPPED",
        inventoryStatus,
        evidence: [
          maturity?.runtimeEvidence ? "runtime-evidence-present" : "runtime-evidence-missing",
          inventory ? "inventory-record-present" : "inventory-record-missing",
        ],
      };
    }) ?? [];

  return {
    executive: "Executive Governor",
    supervisedGovernors,
    activatedCount: supervisedGovernors.filter(g => g.active).length,
  };
}

export const EXECUTIVE_GOVERNOR_ACTIVATION_BRIDGE_READY = true;
